import React from "react";

const dosRoutes = [
    //Declaration of Security
    {
        path: "/applications/dos/list",
        component: React.lazy(() =>
            import("./DosList")
        ),
    },
    {
        path: "/applications/dos/:viewType/:appId/",
        component: React.lazy(() =>
            import(
                "./DosFormDetails"
            )
        ),
    },
];

export default dosRoutes;